// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"cc96296e","453":"03346f77","460":"4267248f","500":"4766abc6","509":"fd6412b5","671":"2e98227e","752":"409bf5e3","806":"c4cf4b26","820":"5a7a8aaa","870":"b9ca3c39"}[chunkId] + ".chunk.js";
};